import React from 'react';
import { shape, string, oneOfType, number, bool, object, oneOf } from 'prop-types';
import PriceMiniatureComponent from './PriceMiniature';
import PriceDefaultComponent from './PriceDefault';
import { Unavailable, UnavailableLabel } from './price.styles';
import { unavailable } from './price.text';
import { MINIATURE, GALLERY } from '../../constants';
/**
 * @function
 * @name Price
 * @prop {number|string} price - price from (original price)
 * @prop {number|string} fullPrice - price to (current sale price)
 * @prop {number|string} bestPrice - price with some discount
 */

const Price = ({
  display,
  price,
  paymentMethodDescription,
  bestPrice,
  fullPrice,
  discount,
  installment,
  showInCashInfo,
  showDiscount,
  showDiscountOnlyCashInfo,
  isList,
  minimumInstallment,
  installmentFormat,
  style,
  hideOriginalPrice
}) => {
  const finalPrice = bestPrice || fullPrice || price;
  const showInCash = Boolean(showInCashInfo && price !== finalPrice && Number(discount));

  if (!finalPrice) {
    return /*#__PURE__*/React.createElement(Unavailable, {
      "data-testid": "price-unavailable"
    }, /*#__PURE__*/React.createElement(UnavailableLabel, {
      display: display
    }, unavailable));
  }

  return display === MINIATURE ? /*#__PURE__*/React.createElement(PriceMiniatureComponent, {
    style: style,
    price: finalPrice,
    showInCashInfo: showInCash,
    paymentMethodDescription: paymentMethodDescription
  }) : /*#__PURE__*/React.createElement(PriceDefaultComponent, {
    style: style,
    price: price,
    finalPrice: finalPrice,
    discount: discount,
    installment: installment,
    showInCashInfo: showInCash,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    paymentMethodDescription: paymentMethodDescription,
    isList: isList,
    minimumInstallment: minimumInstallment,
    installmentFormat: installmentFormat,
    hideOriginalPrice: hideOriginalPrice
  });
};

process.env.NODE_ENV !== "production" ? Price.propTypes = {
  display: string,
  isList: bool,
  price: oneOfType([string, number]),
  bestPrice: oneOfType([string, number]),
  fullPrice: oneOfType([string, number]),
  discount: oneOfType([string, number]),
  hideOriginalPrice: bool,
  installment: shape({
    amount: oneOfType([string, number]),
    paymentMethodDescription: string,
    quantity: oneOfType([string, number]),
    totalAmount: oneOfType([string, number])
  }),
  installmentFormat: oneOf(['short', 'full', null]),
  minimumInstallment: number,
  paymentMethodDescription: string,
  showInCashInfo: bool,
  showDiscount: bool,
  showDiscountOnlyCashInfo: bool,
  style: object
} : void 0;
Price.defaultProps = {
  display: GALLERY,
  isList: true,
  price: '',
  bestPrice: '',
  discount: '',
  hideOriginalPrice: false,
  installment: {
    amount: '',
    paymentMethodDescription: '',
    quantity: '',
    totalAmount: ''
  },
  installmentFormat: '',
  minimumInstallment: 1,
  showInCashInfo: true,
  showDiscount: false,
  showDiscountOnlyCashInfo: false
};
export default Price;